/**
 * Single source of truth for task status values.
 *
 * Mirrors the `task_status` pgEnum in `lib/db/schema.ts` (keep the two in sync —
 * the DB enum is authoritative for migrations, this array is authoritative for
 * application code). Client-safe: no `server-only`, no db imports, so both the
 * task board and the chat artifacts can import it.
 */
export const TASK_STATUS_VALUES = [
  "scheduled",
  "todo",
  "in_progress",
  "needs_review",
  "done",
  "canceled",
  "failed",
] as const;

export type TaskStatus = (typeof TASK_STATUS_VALUES)[number];

/** Statuses a user may pick directly (excludes agent-driven `scheduled`/terminal `canceled`/`failed`). */
export const USER_PICKABLE_TASK_STATUS_VALUES = [
  "todo",
  "in_progress",
  "needs_review",
  "done",
] as const satisfies readonly TaskStatus[];

export function isTaskStatus(value: unknown): value is TaskStatus {
  return (
    typeof value === "string" &&
    (TASK_STATUS_VALUES as readonly string[]).includes(value)
  );
}
